{
  "$id": "module://retirement-eligibility-config",
  "$schema": "wealthlane://schemas/domain",
  "title": "Retirement Configuration",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "eligibilityCriteriaId": {
      "type": "string",
      "title": "Eligibility Criteria",
      "widget": "select",
      "noBlank": true
    },
    "eligibilityCriteria": {
      "type": "string",
      "title": "Eligibility Criteria Label",
      "widget": "hidden"
    },
    "eligibilityOption": {
      "type": "string",
      "title": "Eligibility Option",
      "widget": "hidden"
    },
    "ageYear": {
      "type": "string",
      "title": "",
      "widget": "text",
      "endAddon": "Year",
      "adapterProps": { "hideLabel": true },
      "pattern": "^[0-9][0-9]*$"
    },
    "ageMonth": {
      "type": "string",
      "title": "",
      "widget": "text",
      "endAddon": "Month",
      "adapterProps": { "hideLabel": true },
      "pattern": "^[0-9][0-9]*$"
    },
    "tenureCompletedYear": {
      "type": "string",
      "title": "",
      "widget": "text",
      "endAddon": "Year",
      "adapterProps": { "hideLabel": true },
      "pattern": "^[0-9][0-9]*$"
    },
    "tenureCompletedMonth": {
      "type": "string",
      "title": "",
      "widget": "text",
      "endAddon": "Month",
      "adapterProps": { "hideLabel": true },
      "pattern": "^[0-9][0-9]*$"
    }
  }
}
